<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24"  >Giáo viên</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="stafftypeofdisability.fullName" [ngModelOptions]="{standalone: true}" type="text" disabled="true">
        </nz-form-control>
        </nz-form-item >
      </div>
      <div  nz-col nzSm="24" nzMd="24" nzLg="24" nzXl="24">
        <nz-form-item>
          <nz-form-label nzSpan="24">Loại khuyết tật</nz-form-label>
          <asc-autocomplete [ascModel]="typeOfDisabilitysControl" (ascModelChange)="changeTypeOfDisabilitys($event)"
            [placeholder]="'Chọn loại khuyết tật'" [getListAC]="getTypeOfDisabilitysACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
      </div>
  </div>
  <div *nzModalFooter> 
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    
  </div>
</form>